import React from 'react';
import { ReactComponent as SuccessIcon } from '@crazyegginc/hatch/dist/images/icon-tick-circle-filled.svg';

import { VerticalLine } from './VerticalLine';
import { RenderInfos } from './RenderInfos';
import { RenderWarnings, hasRenderableWarning } from './RenderWarnings';
import { useAuthContext } from '/src/hooks';

function DefaultCard({ children }) {
  return (
    <div className="mt-10 flex h-full w-full items-stretch rounded-md bg-alice-blue-500 px-[30px] pb-10 pt-[30px]">
      {children}
    </div>
  );
}

export function RenderSuccess({
  data,
  originalUrl,
  finalUrl,
  CardComponent = DefaultCard,
  ui = {},
  successTitle,
  successDescription,
}) {
  const { warnings, infos, consoleErrors, cookiesSuccessfullySet } = data;
  const { sessionInfo } = useAuthContext();
  const isImpersonated = sessionInfo?.isImpersonated ?? false;
  const {
    titleClassName = '',
    descriptionClassName = '',
    iconClassName = '',
    iconContainerClassName = '',
    iconContainerEmptyClassName = '',
    contentClassName = '',
  } = ui;

  const failedCookies = cookiesSuccessfullySet?.filter((c) => !c.success) ?? [];
  const shouldRenderWarnings = hasRenderableWarning(warnings, { isImpersonated });

  const hasExtra = shouldRenderWarnings || (infos || []).length > 0 || failedCookies.length > 0;

  const resolvedTitle = successTitle ?? 'Crazy Egg Installed';

  const defaultDescription = (
    <>
      Crazy Egg is correctly installed on <strong>{finalUrl}</strong>
    </>
  );

  const resolvedDescription =
    typeof successDescription === 'function'
      ? successDescription({ originalUrl, finalUrl })
      : (successDescription ?? defaultDescription);

  return (
    <>
      <CardComponent>
        <div
          className={`relative mr-[25px] w-10 flex-shrink-0 ${hasExtra ? iconContainerClassName : iconContainerEmptyClassName}`.trim()}
        >
          <SuccessIcon
            className={`h-10 w-10 fill-current text-lima-500 ${iconClassName}`.trim()}
            aria-label="success"
          />
          {hasExtra && <VerticalLine className={ui.verticalLineClassName} />}
        </div>
        <div className={`flex h-full w-full flex-col items-start ${contentClassName}`.trim()}>
          <h3 className={`text-header-4 ${titleClassName}`.trim()}>{resolvedTitle}</h3>
          <p className={`text-body-2 leading-snug ${descriptionClassName}`.trim()}>{resolvedDescription}</p>
          <RenderWarnings warnings={warnings} finalUrl={finalUrl} failedCookies={failedCookies} ui={ui} />
          <RenderInfos
            infos={infos}
            consoleErrors={consoleErrors}
            finalUrl={finalUrl}
            originalUrl={originalUrl}
            ui={ui}
          />
        </div>
      </CardComponent>
    </>
  );
}
